 const  defaultFonts = [
    {
        disabled: true,
        label: 'Select a Font',
        value: ''
    },
    {
        label: 'Default',
        value: 'default'
    },
    {
        label: 'Arial',
        value: 'Arial, sans-serif'
    },
    {
        label: 'Georgia',
        value: 'Georgia, serif'
    },
    {
        label: 'Helvetica',
        value: 'Helvetica, sans-serif'
    },
    {
        label: 'Times New Roman',
        value: '"Times New Roman", Times, serif'
    },
    {
        label: 'Courier New',
        value: '"Courier New", Courier, monospace'
    },
    {
        label: 'Verdana',
        value: 'Verdana, sans-serif'
    },
    {
        label: 'Roboto',
        value: '"Roboto", sans-serif'
    }
];

const defaultAppearance = [
    {
        key: 'default',
        name: 'Default',
        style: {
          fontWeight: '400'
        }
      },
    {
    
      key: 'light',
      name: 'Light',
      style: {
        fontWeight: '300'
      }
    },
    {
      key: 'regular',
      name: 'Regular',
      style: {
        fontWeight: '400'
      }
    },
    {
        key: 'medium',
        name: 'Medium',
        style: {
          fontWeight: '500'
        }
      },
      {
        key: 'semi-bold',
        name: 'Semi Bold',
        style: {
          fontWeight: '600'
        }
      },
    {
      key: 'bold',
      name: 'Bold',
      style: {
        fontWeight: '700'
      }
    },
    {
        key: 'bolder',
        name: 'Bolder',
        style: {
          fontWeight: '800'
        }
      },

      {
    
        key: 'light-italic',
        name: 'Light Italic',
        style: {
          fontWeight: '300',
          fontStyle: 'italic'
        }
      },
      {
        key: 'regular-italic',
        name: 'Regular Italic',
        style: {
          fontWeight: '400',
          fontStyle: 'italic'
        }
      },
      {
          key: 'medium-italic',
          name: 'Medium Italic',
          style: {
            fontWeight: '500',
            fontStyle: 'italic'
          }
        },
        {
          key: 'semi-bold-italic',
          name: 'Semi Bold Italic',
          style: {
            fontWeight: '600',
            fontStyle: 'italic'
          }
        },
      {
        key: 'bold-italic',
        name: 'Bold Italic',
        style: {
          fontWeight: '700',
          fontStyle: 'italic'
        }
      },
      {
          key: 'bolder-italic',
          name: 'Bolder Italic',
          style: {
            fontWeight: '800',
            fontStyle: 'italic'
          }
        }
]
  
  const  defaultFontSize = [
    {
        name: 'Small',
        size: 12,
        slug: 'small'
    },
    {
        name: 'Medium',
        size: 16,
        slug: 'meadium'
    },
    {
        name: 'extraMedium',
        size: 18,
        slug: 'extramedium'
    },
    {
        name: 'Big',
        size: 20,
        slug: 'big'
    }
];

  const defaultUnits = [
    { value: 'px', label: 'px', default: 0 },
    { value: '%', label: '%', default: 10 },
    { value: 'em', label: 'em', default: 0 },
];

export {
    defaultFonts,
    defaultAppearance,
    defaultUnits,
    defaultFontSize
   };
